import { Theme, useTheme } from "@/components/theme/themeProvider"
import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import type { SessionBlockAthleteNoteEntity } from "@/modules/sessions/entities/sessionBlockAthleteNoteEntity"
import { ChevronIcon } from "@images/svgIcons/chevronIcon"
import { CoachNoteIcon } from "@images/svgIcons/coachNoteIcon"
import { word } from "@modules/core/utils/i18n"
import { HURichTextView } from "@modules/ui/components/richText/huRichTextView"
import { formatTextToRichText } from "@modules/ui/components/richText/richTextUtils"
import { useState } from "react"

type Props = {
  note: SessionBlockAthleteNoteEntity
  className?: string
} & React.ComponentProps<"div">

export function NoteForAthletesDetails({ note, className, ...props }: Props) {
  const { theme } = useTheme()
  const [isContentDisplayed, setIsContentDisplayed] = useState(true)

  return (
    <div
      className={cn(
        "flex flex-col rounded-3xl border border-borderDefault p-3 pt-2 pl-1",
        theme === Theme.OwnerDark && "bg-neutral-50",
        className,
      )}
      {...props}
    >
      {/* Note card header */}
      <div className="flex flex-row items-center justify-between gap-1">
        <div className="flex flex-row items-center justify-start">
          <CoachNoteIcon color="currentColor" className="text-textDefault-body" />
          <div className="flex flex-col">
            <Text fontStyle="TS" className="text-textDefault-body">
              {word("sessionForm.blocks.note_for_athletes")}
            </Text>
          </div>
        </div>

        <Button variant="ghost" size="iconMd" onClick={() => setIsContentDisplayed(!isContentDisplayed)}>
          <ChevronIcon color="currentColor" className={isContentDisplayed ? "rotate-180" : "rotate-0"} />
        </Button>
      </div>

      {/* Note card content */}
      {isContentDisplayed && (
        <div className="pl-12.5">
          <HURichTextView value={formatTextToRichText(note.note)} paragrapheFontStyle="BS" />
        </div>
      )}
    </div>
  )
}
